export default __webpack_public_path__ + "static/media/gallery_00.fd40040e.jpg";